import { App as AntApp, ConfigProvider } from 'antd';
import { AppRoutes } from '@/routes';
import { getAntdTheme } from '@/config/antdTheme';
import { useAuthSession } from '@/hooks/useAuthSession';
import { NOTIFY_DURATION_SECONDS, NOTIFY_MAX_COUNT } from '@/utils/notify';
import { useResolvedTheme, useThemeEffect } from '@/hooks/useResolvedTheme';

function AppContent() {
  useAuthSession();

  return <AppRoutes />;
}

export default function App() {
  const resolvedTheme = useResolvedTheme();
  useThemeEffect();

  return (
    <ConfigProvider theme={getAntdTheme(resolvedTheme)}>
      <AntApp
        notification={{
          placement: 'topRight',
          top: 76,
          duration: NOTIFY_DURATION_SECONDS,
          pauseOnHover: true,
          maxCount: NOTIFY_MAX_COUNT,
        }}
      >
        <AppContent />
      </AntApp>
    </ConfigProvider>
  );
}
